import React, { useEffect, useState } from "react";
import "./App.css";
import { MahaLogo, MhLogo, India } from "./media";
import styled from "styled-components";
import { Form, Input, Radio, Button, Select, message } from "antd";
import "antd/dist/antd.css";
import data from "./data.json";
import axios from "axios";
function App() {
  const { Option } = Select;

  const [name, setName] = useState("");
  const [aadharnumber, setAadharNumber] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [district, setDistrict] = useState("");
  const [taluka, setTaluka] = useState("");
  const [address, setAddress] = useState("");
  const [haveGasConnection, setHaveGasConnection] = useState(true);
  const [belongToSC, setBelongToSC] = useState(false);
  const [talukaKey, setTalukaKey] = useState(0);
  const nameChange = (e) => {
    setName(e.target.value);
  };
  const mobileChange = (e) => {
    setPhoneNumber(e.target.value);
  };
  const addressChange = (e) => {
    setAddress(e.target.value);
  };
  const talukaChange = (e) => {
    setTaluka(e.target.value);
  };
  const aadharChange = (e) => {
    setAadharNumber(e.target.value);
  };
  const districtChange = (e) => {
    setDistrict(e.target.value);
    console.log(e.target.value);
  };
  const casteChange = (e) => {
    setBelongToSC(e.target.value);
  };
  const gasChange = (e) => {
    setHaveGasConnection(e.target.value);
  };

  const handleSubmit = () => {
    if (name == "" || null) {
      alert("Name field is empty");
    } else if (phoneNumber.length != 10) {
      alert("Phone number should not be empty and must be 10 digits");
    } else if (aadharnumber.length != 12) {
      alert("Aadhar number should be 12 digits");
    } else if (address == "" || null) {
      alert("Address is empty");
    } else if (district == "" || null) {
      alert("District is empty");
    } else if (taluka == "" || null) {
      alert("Taluka is empty");
    } else {
      axios
        .post("http://3.109.48.93/api/application", {
          name: name,
          aadharNumber: aadharnumber,
          phoneNumber: phoneNumber,
          district: district,
          taluka: taluka,
          address: address,
          haveGasConnection: haveGasConnection,
          belongToSC: belongToSC,
        })
        .then((response) => {
          const status = response.request.status;
          if (status == 200) {
            message.success("Your Form has been successfully submitted");
          } else {
            message.error("Your Form wasn't submitted");
          }
        });
    }
  };

  useEffect(() => {
    window.location.replace(
      "http://mybucketbhugolgis1.s3-website.us-east-2.amazonaws.com/"
    );
  }, []);

  const [selectVisible, setSelectVisible] = useState(true);
  return (
    <MainContainer>
      <Container>
        <IndiaLogo src={India} />
        <StateLogo src={MhLogo} />
        <MahaPreitLogo src={MahaLogo} />
      </Container>
      <SubmitForm layout="vertical">
        <Heading>
          Clean Cooking - Cookstoves distribution (निर्धुर चूल वाटप अभियान)
        </Heading>
        <span>
          <Form.Item
            label="Full Name (पूर्ण नाव)"
            name="name"
            rules={[
              {
                required: true,
                message: "Please input your full name!",
              },
            ]}
          >
            <Input
              name="name"
              placeholder="Enter your Name"
              onChange={nameChange}
              value={name}
            />
          </Form.Item>
          <Form.Item
            label="Mobile no. as per Aadhar (भ्रमणध्वनी क्रमांक आधार नुसार)"
            name="mobile"
            rules={[
              {
                required: true,
                message: "Please input your Mobile Number!",
              },
            ]}
          >
            <Input
              name="mobile"
              placeholder="Enter your Mobile Number"
              onChange={mobileChange}
              value={phoneNumber}
            />
          </Form.Item>
          <Form.Item
            label="Aadhar Number (आधार क्रमांक)"
            name="aadhar"
            rules={[
              {
                required: true,
                message: "Please input your Aadhar Number!",
              },
            ]}
          >
            <Input
              name="aadhar"
              placeholder="Enter your Aadhar Number"
              onChange={aadharChange}
              value={aadharnumber}
            />
          </Form.Item>
          <Form.Item
            label="Address (पत्ता)"
            name="address"
            rules={[
              {
                required: true,
                message: "Please input your Address!",
              },
            ]}
          >
            <Input
              name="address"
              placeholder="Enter your Address"
              onChange={addressChange}
              value={address}
            />
          </Form.Item>
          <Form.Item
            label="District (जिल्हा)"
            name="district"
            rules={[
              {
                required: true,
                message: "Please input your District!",
              },
            ]}
          >
            <Select
              showSearch
              placeholder="Select district"
              optionFilterProp="children"
              onChange={(v, k) => {
                setDistrict(v);
                setTalukaKey(k.key);
                setSelectVisible(false);
              }}
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              value={district}
            >
              {data.map((dis, index) => {
                return (
                  <Option
                    key={index}
                    value={dis.district_name}
                    onChange={districtChange}
                  >
                    {dis.district_name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          <Form.Item
            label="Taluka (तालुका)"
            name="taluka"
            rules={[
              {
                required: true,
                message: "Please input your Taluka!",
              },
            ]}
          >
            <Select
              showSearch
              placeholder="Select taluka"
              optionFilterProp="children"
              onChange={(v) => {
                setTaluka(v);
              }}
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              disabled={selectVisible}
            >
              {data[talukaKey].talukas.map((tal) => {
                return (
                  <Option value={tal.taluka_name}>{tal.taluka_name}</Option>
                );
              })}
            </Select>
          </Form.Item>

          <Form.Item label="Do you have LPG Gas Connection ? (तुमच्याकडे एलपीजी गॅस कनेक्शन आहे का ?)">
            <Radio.Group onChange={gasChange} value={haveGasConnection}>
              <Radio value={true}>Yes</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item label="Do you belong to SC Caste ? (तुम्ही एससी जातीचे आहात का ?)">
            <Radio.Group onChange={casteChange} value={belongToSC}>
              <Radio value={true}>Yes</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          </Form.Item>
          <SubmitButton type="primary" htmlType="submit" onClick={handleSubmit}>
            Submit
          </SubmitButton>
        </span>
      </SubmitForm>
    </MainContainer>
  );
}

export default App;

export const MainContainer = styled.div`
  margin: 30px;
`;
export const SubmitForm = styled(Form)`
  margin: 30px;
`;
export const Heading = styled.h2`
  margin: 20px 0px;
`;
export const Container = styled.div`
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
`;
export const IndiaLogo = styled.img`
  width: 100px;
  height: 100px;
`;
export const MahaPreitLogo = styled.img`
  height: 60px;
  width: 300px;
  margin-top: 30px;
`;
export const StateLogo = styled.img`
  width: 100px;
  height: 100px;
`;
export const SubmitButton = styled(Button)`
  margin-bottom: 50px;
`;
